import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const otnSingleHtml =
'<div class="form-group text-left mt-2">' +
  '<label for="template-name">' + lang.otn_single_html_template_name + '</label>' +
  '<input type="text" id="template-name" class="form-control">' +
'</div>' +

'<div class="form-group text-left mt-3">' +
  '<label class="pb-1">' + lang.otn_single_html_labels + '</label>' +
  '<select id="label-ids" class="form-control select2" multiple=""></select>' +
'</div>' +

'<div class="form-group text-left d-none mt-3">' +
  '<label>' + lang.otn_single_html_sequence + '</label>' +
  '<select id="sequence" class="form-control select2"></select>' +
'</div>' +

// Adds html for delay system
delayHtml
